// Quick-pick suggestions for the locale field. This is NOT an allow-list — the field is
// free-text, validated by isValidLocale (BCP-47), so any valid locale code is accepted.
export const COMMON_LOCALES: { code: string; label: string }[] = [
  { code: "en-GB", label: "en-GB — English (UK)" },
  { code: "en-US", label: "en-US — English (US)" },
  { code: "zh-CN", label: "zh-CN — Chinese (Simplified)" },
  { code: "es-ES", label: "es-ES — Spanish" },
  { code: "pt-PT", label: "pt-PT — Portuguese" },
  { code: "de-DE", label: "de-DE — German" },
  { code: "fr-FR", label: "fr-FR — French" },
  { code: "it-IT", label: "it-IT — Italian" },
];
